export default /* glsl */`
varying vec2 vUv;
uniform vec3 color;

void main() {
    if( fract(vUv.y*50.0) > 0.9 )
        discard;
    gl_FragColor = vec4(color,1.0-abs(vUv.x-0.5)*2.0); 
}
`;